import { FC } from "react";

import { Link } from "react-router-dom";

import { Breadcrumbs, Crumb, DevPage, Section } from "./common";

const ListItem: FC<{
  path: string;
  title: string;
  description: string;
}> = ({ path, title, description }) => (
  <li>
    <Link to={path}>{title}</Link>
    {description}
  </li>
);

export const DevHomePage: FC = () => {
  return (
    <DevPage
      title="Developer and Administrator Utilities"
      breadcrumbs={
        <Breadcrumbs>
          <Crumb>
            <Link to="/">Home</Link>
          </Crumb>
          <Crumb>Developer and Administrator Utilities</Crumb>
        </Breadcrumbs>
      }
    >
      <Section subtitle="Utilities">
        <ul>
          <ListItem
            path="onboard"
            title="Onboard Community"
            description="guided wizard to create a new community (org, directory, branding, SSO)"
          />
          <ListItem
            path="scheduled_job"
            title="Scheduled Jobs"
            description="administration panel"
          />
          <ListItem
            path="permission"
            title="Permissions"
            description="administration panel"
          />
          <ListItem
            path="org"
            title="Orgs"
            description="administration panel"
          />
          <ListItem
            path="org_config"
            title="Org Config"
            description="edit columns and JSON metadata for rv2_org_config rows"
          />
          <ListItem
            path="partner_org"
            title="Partner Orgs"
            description="administration panel for rubiPARTNER partners"
          />
          <ListItem
            path="onboard_partner"
            title="Onboard Partner"
            description="guided wizard to create a new rubiPARTNER partner (partner_org + hosting org)"
          />
          <ListItem
            path="translate-all-surveys"
            title="Translate All Surveys"
            description="translate survey names and descriptions to multiple languages"
          />
          <ListItem
            path="rms_export_error"
            title="RMS Export Errors"
            description="view and fix RMS export serialization errors"
          />
          <ListItem
            path="linter-schema"
            title="Linter Schema"
            description="manage survey field naming validation rules"
          />
          <ListItem
            path="crime-types"
            title="Crime Types"
            description="manage alert associated crime type definitions"
          />
          <ListItem
            path="bulletin-types"
            title="Alert Types"
            description="manage alert bulletin type definitions"
          />
          <ListItem
            path="region"
            title="Regions"
            description="manage GeoDataFiles, Subregions, and Regions — an org's geographic jurisdiction"
          />
        </ul>
      </Section>
    </DevPage>
  );
};
